import { CRS_CONSTANTS } from '../../pages/constants/crsContants';

import { CustomerListModule } from './apiModules/ListingPageModules/customerListModule';
import { ClusterListModule } from './apiModules/ListingPageModules/clusterListModule';
import { SegmentListModule } from './apiModules/ListingPageModules/segmentListModule';
import { CustomerTypeListModule } from './apiModules/ListingPageModules/customerTypeListModule';
import { RiskLevelChangeListModule } from './apiModules/ListingPageModules/riskLevelChangeListModule';

export class NetworkLayer {
  constructor() {
    const { CRS_BASE_URL, HTTP_HEADERS } = CRS_CONSTANTS;
    this.baseUrl = CRS_BASE_URL;
    this.httpHeaders = HTTP_HEADERS;

    this.customerListModule = new CustomerListModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );
    this.clusterListModule = new ClusterListModule(CRS_BASE_URL, HTTP_HEADERS);
    this.segmentListModule = new SegmentListModule(CRS_BASE_URL, HTTP_HEADERS);
    this.customerTypeListModule = new CustomerTypeListModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );
    this.riskLevelChangeListModule = new RiskLevelChangeListModule(
      CRS_BASE_URL,
      HTTP_HEADERS
    );
  }

  customerListAPI = async (payload) =>
    await this.customerListModule.fetchCustomerList(payload);
  clusterListAPI = async (payload) =>
    await this.clusterListModule.fetchClusterList(payload);
  segmentListAPI = async (payload) =>
    await this.segmentListModule.fetchSegmentList(payload);
  customerTypeListAPI = async (payload) =>
    await this.customerTypeListModule.fetchCustomerTypeList(payload);
  riskLevelChangeListAPI = async (payload) =>
    await this.riskLevelChangeListModule.fetchRiskLevelChangeList(payload);
}
